import React from 'react';
import './mercadoPublico.css'

const EmptyData = () => {
    return (
        <div className="w-100 h-100 bg-white pl-0">
            <h2 className="bold-title-hyundai text-center pt-svs f-responsive-14">No hay vehiculos para mostrar.</h2>
        </div>
    );
}

export default EmptyData;